<template>
  <div>
  <div class="content">
    <div class="service_content">
        <p class="title">
          参考资料
        </p>
        <div style="width:940px;margin:0 auto">
        <garden0 v-if="gee.ga0"></garden0>
        <garden24 v-if="gee.ga24"></garden24>
        <garden25 v-if="gee.ga25"></garden25>
        <garden26 v-if="gee.ga26"></garden26>
        <garden27 v-if="gee.ga27"></garden27>
        <garden28 v-if="gee.ga28"></garden28>
        <garden29 v-if="gee.ga29"></garden29>
        <garden1 v-if="gee.ga1"></garden1>
        <garden2 v-if="gee.ga2"></garden2>
        <garden3 v-if="gee.ga3"></garden3>
        <garden4 v-if="gee.ga4"></garden4>
        <garden5 v-if="gee.ga5"></garden5>
        <garden6 v-if="gee.ga6"></garden6>
        <garden7 v-if="gee.ga7"></garden7>
        <garden8 v-if="gee.ga8"></garden8>
        <garden9 v-if="gee.ga9"></garden9>
        <garden22 v-if="gee.ga22"></garden22>
        <garden23 v-if="gee.ga23"></garden23>
        <garden10 v-if="gee.ga10"></garden10>
        <garden11 v-if="gee.ga11"></garden11>
        <garden12 v-if="gee.ga12"></garden12>
        <garden13 v-if="gee.ga13"></garden13>
        <garden14 v-if="gee.ga14"></garden14>
        <garden15 v-if="gee.ga15"></garden15>
        <garden16 v-if="gee.ga16"></garden16>
        <garden17 v-if="gee.ga17"></garden17>
        <garden18 v-if="gee.ga18"></garden18>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import garden0 from './garden/garden0'
import garden24 from './garden/garden24'
import garden25 from './garden/garden25'
import garden26 from './garden/garden26'
import garden27 from './garden/garden27'
import garden28 from './garden/garden28'
import garden29 from './garden/garden29'
import garden1 from './garden/garden1'
import garden2 from './garden/garden2'
import garden3 from './garden/garden3'
import garden4 from './garden/garden4'
import garden5 from './garden/garden5'
import garden6 from './garden/garden6'
import garden7 from './garden/garden7'
import garden8 from './garden/garden8'
import garden9 from './garden/garden9'
import garden22 from './garden/garden22'
import garden23 from './garden/garden23'
import garden10 from './garden/garden10'
import garden11 from './garden/garden11'
import garden12 from './garden/garden12'
import garden13 from './garden/garden13'
import garden14 from './garden/garden14'
import garden15 from './garden/garden15'
import garden16 from './garden/garden16'
import garden17 from './garden/garden17'
import garden18 from './garden/garden18'
export default {
components:{garden0,garden24,garden25,garden26,garden27,garden28,garden29,garden1,garden2,garden3,garden4,garden5,garden6,garden7,garden8,garden9,garden22,garden23,garden10,garden11,garden12,garden13,garden14,garden15,garden16,garden17,garden18},
data(){
    return{
        gee:{ga0:false,ga24:false,ga25:false,ga26:false,ga27:false,ga28:false,ga29:false,ga1:false,ga2:false,ga3:false,ga4:false,ga5:false,ga6:false,ga7:false,ga8:false,ga9:false,ga22:false,ga23:false,ga10:false,ga11:false,ga12:false,ga13:false,ga14:false,ga15:false,ga16: false,ga17:false,ga18:false},

}


    
},
created(){
    var rt=this.$route.query.id
    this.gee["ga"+rt +""]=true
}
}
</script>

<style scoped>
  .content{
    background: url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=59) no-repeat top;
    width: 100%;
    min-height: 600px;
    padding-top: 236px;
  }
  .service_content{
    width: 990px;
    margin: 0 auto;
    background: #fff;
    border-radius: 10px;
    padding: 30px;
    box-shadow: 0 0 20px -5px #ccc; 
    min-height: 600px;
    padding-bottom: 50px;
    text-align: justify;
  }
  .service_content .title{
    color: #5f5f5f;
    border-bottom: 1px dashed #a8a8a8;
    line-height: 40px;
    font-size: 22px;
  }
  .text_content{
    text-indent: 2em;
    font-size: 14px;
    line-height: 20px;
    color:#6f6f6f;
    padding: 10px 0;
    text-align: justify;
  }
  .title2{
    font-size: 16px;
    color: #5d0f0b;
    border-left: 4px solid #e24a49;
    font-weight: bold;
    padding-left: 10px;
    margin: 15px 0;
  }
</style>